import Layout from '../../components/Layout/Layout';

const TestComponentV2 = () => {
  return (
    <Layout>
      <h1>Composant de test technique (V2)</h1>
    </Layout>
  );
};

export default TestComponentV2; 